export const LocalStorageKeys = {
	token: 'token',
	accessToken: 'accessToken',
	refreshToken: 'refreshToken',
	id: 'id',
	preferredLocale: 'preferredLocale',
	wasPwaModalSuggested: 'wasPwaModalSuggested',
	workoutRedirectURL: 'workoutRedirectURL',
	coachChatVisibleSessionId: 'coach_chat_visible_session_id',
}
